export function setTitle(title) {
	return {
		type: "SET_TITLE",
		title
	};	
}

export function setKeywords(keywords) {
	return {
		type: "SET_KEYWORDS",
		keywords
	};	
}

export function setThemes(themes) {
	return {
		type: "SET_THEMES",
		themes
	};	
}

export function setAuthors(authors) {
	return {
		type: "SET_AUTHORS",
		authors
	};	
}

export function setInstitutions(institutions) {
	return {
		type: "SET_INSTITUTIONS",
		institutions
	};	
}

export function setFolder(folder) {
	return {
		type: "SET_FOLDER",
		folder
	};	
}

export function setDatetime(datetime) {
	return {
		type: "SET_DATETIME",
		datetime
	};	
}

export function setStartCoverageDate(startCoverageDate) {
	return {
		type: "SET_START_COVERAGE_DATE",
		startCoverageDate
	};	
}

export function setEndCoverageDate(endCoverageDate) {
	return {
		type: "SET_END_COVERAGE_DATE",
		endCoverageDate
	};	
}

export function setDescription(description) {
	return {
		type: "SET_DESCRIPTION",
		description
	};	
}

export function setUrl(url) {
	return {
		type: "SET_URL",
		url
	};	
}


// WEBPACK FOOTER //
// ./src/state/documents/metadata/actions.js